import { render, staticRenderFns } from "./mySciencePopularization.vue?vue&type=template&id=02c1f1e9&scoped=true&"
import script from "./mySciencePopularization.vue?vue&type=script&lang=js&"
export * from "./mySciencePopularization.vue?vue&type=script&lang=js&"
import style0 from "./mySciencePopularization.vue?vue&type=style&index=0&id=02c1f1e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c1f1e9",
  null
  
)

export default component.exports